import $api from "@/frontend/shared/api/axios";

export async function postBulkAddCompetitors(competitorIds: number[]) {
  const response = await $api.post(`/founder-revisions/competitors`, { competitorIds });
  return response.data.data;
}
